import { render, staticRenderFns } from "./RbuImportSorDialog.vue?vue&type=template&id=4210f951"
import script from "./RbuImportSorDialog.vue?vue&type=script&lang=js"
export * from "./RbuImportSorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports